<template>
  <el-dialog
    :visible.sync="showDialog"
    class="dialog-apply"
    :title="title"
    top="0"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form :model="formData" :rules="rules" ref="modifyForm">
      <div class="form-item">
        <div class="label">姓名<span class="requiredcolor">*</span></div>
        <el-form-item prop="append_order_remark_001">
          <el-input
              class="custom-input"
              v-model="formData.append_order_remark_001"
              placeholder="请输入姓名"
              maxlength="32"
          ></el-input>
        </el-form-item>
      </div>
      <div class="form-item">
        <div class="label">手机号码<span class="requiredcolor">*</span></div>
        <el-form-item prop="append_order_remark_002">
          <el-input
              class="custom-input phone"
              v-model="formData.append_order_remark_002"
              placeholder="请输入手机号码"
              maxlength="11"
          ></el-input>
          <el-button class="send-code" @click="handleSendPhoneCode">{{ sendCodeText }}</el-button>
        </el-form-item>
      </div>
      <div class="form-item" v-if="codeShow">
        <div class="label">验证码<span class="requiredcolor">*</span></div>
        <el-form-item prop="phone_code">
          <el-input
              class="custom-input phone"
              v-model="formData.phone_code"
              placeholder="请输入验证码"
              maxlength="11"
          ></el-input>
        </el-form-item>
      </div>
      <div class="form-item">
        <div class="label">公司名称<span class="requiredcolor">*</span></div>
        <el-form-item prop="append_order_remark_003">
          <el-input
            class="custom-input"
            v-model="formData.append_order_remark_003"
            placeholder="请输入公司明细"
            maxlength="32"
          ></el-input>
        </el-form-item>
      </div>
      <div class="form-item">
        <div class="label">微信号<span class="requiredcolor">*</span></div>
        <el-form-item prop="append_order_remark_004">
          <el-input
            class="custom-input"
            v-model="formData.append_order_remark_004"
            placeholder="请输入微信号"
            maxlength="11"
          ></el-input>
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <div>
        <el-button class="custom-button btn-determine" @click="handleSubmit">提交</el-button>
      </div>

      <div class="weichat-box">
        <div class="box-inner">
          <div>
            <div class="inner-text">独自开企业微信</div>
            <div>扫描二维码加入</div>
          </div>
          <div class="qr-code">
            <img class="code-img" src="../../assets/image/qr_code.jpg" alt="">
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import {phoneValidator, timeLoop} from "@/assets/js/util";
import lodash from "lodash";
// import { city } from "@/assets/js/city";
import {city} from "@/utils/cityjs/applycity";
import {developLangOptions} from "@/assets/js/dictionary";
import CustomSelect from "@/components/CustomSelect.vue";
import pageCommon from "@/utils/pagecommon";
import caseApi from "@/api/case";
import taskApi from "@/api/task";
import accountApi from "@/api/account";

export default {
  name: "ApplyTaste",
  components: {
    CustomSelect,
  },
  data() {
    return {
      showDialog: false,
      devlangOptions: lodash.cloneDeep(developLangOptions),
      origin_devlangOptions: [],
      hostUrl: window.location.host,
      formData: {
        append_order_remark_001: "",
        append_order_remark_002: "",
        append_order_remark_003: "",
        append_order_remark_004: "",
        phone_code: ""
      },
      timerObj: {
        timer: null,
      },
      timeCount: 0,
      maxTime: 60,
      sendCodeText: "发送验证码",
      provinces: city,
      cities: [],
      rules: {
        append_order_remark_001: [
          { required: true, message: "请填写姓名", trigger: "blur" },
        ],
        append_order_remark_002: [
          { required: true, message: "请填写电话", trigger: "blur" },
        ],
        append_order_remark_003: [
          { required: true, message: "请填写公司名称", trigger: "blur" },
        ],
        append_order_remark_004: [
          { required: true, message: "请填写微信号", trigger: "blur" },
        ],
        phone_code: [
          { required: true, message: "请填写验证码", trigger: "blur" },
        ],
      },
      showFileList: [],
      isRequesting: false,
      codeShow: false
    };
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    goodData: {
      type: Object,
      default: () => {
        return null;
      },
    },
    id: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    let _this = this;
  },
  computed: {
    userInfo: function () {
      let _this = this;
      return _this.$store.state.user;
    },
    userShopInfo: function () {
      let _this = this;
      return _this.$store.state.userShopInfo;
    },
  },
  methods: {
    handleSubmit: function () {
      let _this = this;
      if (_this.isRequesting) {
        return;
      }
      // _this.isRequesting = true;
      _this.$refs["modifyForm"].validate((valid) => {
        if (valid) {
          _this.preSubmitMain();
        }
      });
    },
    preSubmitMain: function () {
      let _this = this;
      let requestData = {
        mid_table_remark_001: _this.formData.append_order_remark_001,
        mid_table_remark_002: _this.formData.append_order_remark_002,
        mid_table_remark_003: _this.formData.append_order_remark_003,
        mid_table_remark_004: _this.formData.append_order_remark_004,
        isloading: true,
      };
      console.log(requestData)
      // console.log(requestData,"xxxxx")
      pageCommon.apiRequestCommon(caseApi, "applyTaste", requestData).then(
        (res) => {
          _this.$message.success("提交成功，将在24小时之内跟您联系~");
          _this.showDialog = false;
        },
        (err) => {
          _this.isRequesting = false;
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
        }
      );
    },


    handleSendPhoneCode: function() {
      let _this = this;
      if (_this.timeCount > 0 || _this.isRequesting) {
        return;
      }
      if (!_this.formData.append_order_remark_002) {
        this.$message.error('请输入手机号码~')
        return;
      }
      let reg = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
      let user_phone = _this.formData.append_order_remark_002;
      if (!reg.test(user_phone)) {
        this.$message.error('请输入正确的手机号码~')
        return;
      }
      let requestData = {
        mid_table_remark_002: user_phone,
        isloading: true,
      };
      pageCommon.apiRequestCommon(taskApi, "getApplyInfo", requestData).then(
          (res) => {
            console.log(res)
            if (res.page_content && res.page_content.length) {
              let beforeDate = new Date(this.$moment().subtract(1, 'months').format('yyyy-MM-DD')).getTime()
              let nowDate = new Date(this.$moment(new Date()).format('yyyy-MM-DD')).getTime()
              let insertTime = res.page_content[0].time_insert;
              console.log(this.$moment(new Date(insertTime)).format('yyyy-MM-DD'))
              let insertDate = new Date(this.$moment(new Date(insertTime)).format('yyyy-MM-DD')).getTime()
              console.log(beforeDate)
              console.log(nowDate)
              console.log(insertDate)
              if (insertDate > beforeDate && insertDate <= nowDate) {
                this.$message.error("您已经提交过申请,不能再次提交~");
                setTimeout(() => {
                  this.showDialog = false
                }, 3000)

              } else {
                pageCommon.apiRequestCommon(accountApi, 'sendPhoneCodeByNoPic', { user_phone, isloading: true }).then(res => {
                  _this.isRequesting = false;
                  this.codeShow = true
                  if (_this.timerObj && _this.timerObj.timer) {
                    clearTimeout(_this.timerObj.timer);
                  }
                  // _this.timeCount=_this.maxTime;
                  timeLoop(_this.timerObj, _this.maxTime, function(count) {
                    _this.timeCount = count;
                    if (count <= 0) {
                      _this.sendCodeText = "发送验证码";
                    }
                    if (count > 0) {
                      _this.sendCodeText = `${count}s后可重发`;
                    }
                  });
                }, err => {
                  if (err.sysUserLoginError) {
                    _this.isRequesting = false;
                    _this.$message.error("系统异常，请稍后刷新重试！");
                  } else {
                    _this.isRequesting = false;
                    _this.$message.error(err.data.msg);
                  }

                })
              }

            } else {
              pageCommon.apiRequestCommon(accountApi, 'sendPhoneCodeByNoPic', { user_phone, isloading: true }).then(res => {
                _this.isRequesting = false;
                this.codeShow = true
                if (_this.timerObj && _this.timerObj.timer) {
                  clearTimeout(_this.timerObj.timer);
                }
                // _this.timeCount=_this.maxTime;
                timeLoop(_this.timerObj, _this.maxTime, function(count) {
                  _this.timeCount = count;
                  if (count <= 0) {
                    _this.sendCodeText = "发送验证码";
                  }
                  if (count > 0) {
                    _this.sendCodeText = `${count}s后可重发`;
                  }
                });
              }, err => {
                if (err.sysUserLoginError) {
                  _this.isRequesting = false;
                  _this.$message.error("系统异常，请稍后刷新重试！");
                } else {
                  _this.isRequesting = false;
                  _this.$message.error(err.data.msg);
                }

              })
            }
          },
          (err) => {
            if (err.sysUserLoginError) {
              this.$message.error("系统异常，请稍后刷新重试！");
            } else {
              this.$message.error(err.data.msg);
            }
          }
      );
    },
    // 校验手机号是否正确
    validPhoneNumRight: function() {
      let _this = this;
      return new Promise((resolve, reject) => {
        let formRef = _this.sendphoneValideForName;
        _this.$refs[formRef].validateField(_this.valideFieldPhoneItemName, (valid) => {
          if (!valid) {
            resolve();
            return;
          }
          reject(valid);
        });
      });
    },
  },
  watch: {
    goodData: {
      handler: function (newVal, oldVal) {
        let _this = this;
        _this.formData = {
          receive_name: "",
          phone_user: "",
          append_order_remark_004: "",
          append_order_remark_005: "",
          append_order_remark_006: "",
          province: "",
          city: "",
          append_order_remark_007: "",
          append_order_remark_008: [],
          append_order_remark_009: "",
        };
        _this.showFileList = [];
        _this.$refs["modifyForm"].clearValidate();
        _this.isRequesting = false;
      },
      deep: true,
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.dialog-apply {
  /deep/.el-dialog {
    position: absolute;
    width: 540px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
    .el-dialog__header {
      position: relative;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 30px 38px 40px;
      box-sizing: border-box;
      .el-dialog__title {
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #222222;
        line-height: 20px;
        text-align: center;
        width: 100%;
      }
      .el-dialog__headerbtn {
        position: relative;
        width: 16px;
        height: 16px;
        overflow: hidden;
        background: url("../../assets/icon_dialog_delete.png") no-repeat;
        background-size: 100% 100%;
        top: 0;
        right: 0;
        .el-dialog__close {
          &::before {
            content: none;
          }
        }
      }
    }
    .el-dialog__body {
      position: relative;
      padding: 0px 38px 0;
      width: 100%;
      box-sizing: border-box;
      max-height: calc(100vh - 260px);
      box-sizing: border-box;
      overflow: auto;
    }
    .el-form-item {
      margin-bottom: 22px;
    }
  }
  .width222 {
    width: 222px;
  }
  .width100per {
    width: 100%;
  }
  .item-base {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }
  .form-item {
    display: flex;
    flex-direction: column;
    position: revert;
    /deep/.custom-input {
      .el-input__inner {
        font-size: 16px;
        font-family: Source Han Sans CN;
        // font-weight: bold;
        color: #222222;
        &::-webkit-input-placeholder {
          font-size: 14px;
          // font-family: Source Han Sans CN;
          font-weight: 400;
          // color: #E2E2E2;
        }

        &::-moz-placeholder {
          font-size: 14px;
          // font-family: Source Han Sans CN;
          font-weight: 400;
          // color: #E2E2E2;
        }

        &::-ms-input-placeholder {
          font-size: 14px;
          // font-family: Source Han Sans CN;
          font-weight: 400;
          // color: #E2E2E2;
        }
      }
    }
    .send-code {
      position: absolute;
      right: 0;
      top: 0;
      height: 100%;
      border: none;
      background: transparent;
    }
    .label {
      font-size: 12px;
      font-family: "SourceHanSansCN";
      color: rgb(153, 153, 153);
      margin-bottom: 5px;
      text-align: left;
      .red {
        color: #ff3333;
      }
    }
    .el-select-area {
      /deep/.el-input__inner {
        font-size: 16px;
        font-family: Source Han Sans CN;
        // font-weight: bold;
        color: #222222;
        &::-webkit-input-placeholder {
          font-size: 14px;
          // font-family: Source Han Sans CN;
          font-weight: 400;
          // color: #E2E2E2;
        }

        &::-moz-placeholder {
          font-size: 14px;
          // font-family: Source Han Sans CN;
          font-weight: 400;
          // color: #E2E2E2;
        }

        &::-ms-input-placeholder {
          font-size: 14px;
          // font-family: Source Han Sans CN;
          font-weight: 400;
          // color: #E2E2E2;
        }
      }
    }
    .upload-tip-box {
      display: flex;
      align-items: center;
      .btn-upload {
        width: 70px;
        height: 28px;
        line-height: 28px;
        font-size: 14px;
      }
      .tip {
        font-size: 12px;
        font-family: "SourceHanSansCN";
        color: rgb(153, 153, 153);

        margin-left: 15px;
      }
      /deep/.el-upload {
        border: none;
        width: auto;
        height: auto;
      }
    }
  }
  .filelist-box {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-top: 15px;
    .item {
      display: flex;
      align-items: center;

      border-radius: 4px;
      background-color: rgb(246, 246, 246);
      height: 24px;
      line-height: 24px;
      padding-left: 5px;
      padding-right: 5px;
      box-sizing: border-box;
      margin-right: 5px;

      font-size: 12px;
      font-family: "SourceHanSansCN";
      color: rgb(34, 34, 34);
      .el-icon-close {
        font-size: 12px;
        margin-left: 5px;
        cursor: pointer;
      }
    }
  }
  /deep/.el-dialog__footer {
    width: 100%;
    padding: 0;
    text-align: center;
  }
  /deep/.dialog-footer {
    .custom-button {
      width: 160px;
      height: 46px;
      line-height: 46px;
      font-size: 16px;
      background-color: #2C6CE6;
      color: #FFFFFF;
      margin-bottom: 22px;
    }
  }

  .weichat-box {
    background-color: #F3F5F9;
    padding: 24px 40px;
    .box-inner {
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 14px 34px 14px 44px;
      border-radius: 4px;
      font-size: 14px;
      color: #666666;
      text-align: left;
      position: relative;
      &::before {
        content: "";
        display: block;
        width: 20px;
        height: 20px;
        background-color: #F3F5F9;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: -10px;
        transform: translateY(-50%);
      }
      &::after {
        content: "";
        display: block;
        width: 20px;
        height: 20px;
        background-color: #F3F5F9;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        right: -10px;
        transform: translateY(-50%);
      }
      .inner-text {
        font-size: 18px;
        color: #222222;
        font-weight: bold;
        margin-bottom: 20px;
      }
      .qr-code {
        width: 100px;
        height: 100px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 2px solid #222222;
        .code-img {
          width: 84px;
          height: 84px;
        }
        &::before {
          position: absolute;
          top: 0;
          left: -20px;
          content: "";
          display: block;
          width: 1px;
          height: 100%;
          border-left: 1px dashed rgba(0,0,0,.1);
        }
      }
    }
  }
}
</style>
